import React, {Component} from 'react'

import Dialog from '@material-ui/core/Dialog'
import DialogTitle from '@material-ui/core/DialogTitle'
import DialogContent from '@material-ui/core/DialogContent'
import DialogActions from '@material-ui/core/DialogActions'

import Button from '@material-ui/core/Button'

/**
 * <DeleteCategoryDialog category onDeleteCategory = {category} onCancel = {} />
 */

class DeleteCategoryDialog extends Component {

	render() {

		return <Dialog
			open = {true}
			scroll = "body"
		>

			<DialogTitle>
				Удалить папку
			</DialogTitle>

			<DialogContent style = {{display: "flex", flexDirection: "column"}}>
				Вы уверены, что хотите удалить категорию &laquo;{this.props.category.name}&raquo;?
			</DialogContent>

			<DialogActions>
			
				<Button
					onClick = {e => {
						e.stopPropagation()
						if (typeof this.props.onDeleteCategory === "function") {
							this.props.onDeleteCategory(this.props.category)
						}
					}}
				>Удалить</Button>

				<Button
					onClick = {e => {
						e.stopPropagation()
						if (typeof this.props.onCancel === "function") {
							this.props.onCancel()
						}
					}}
				>Отмена</Button>

			</DialogActions>

		</Dialog>

	}

}

export default DeleteCategoryDialog
